import useApi from './useApi';

import type { ProJobCategoriesForSignup } from '../modules/marketing-pages/marketing-page.types';

interface Param {
  createdDate: number;
}

const useGetProJobCategoriesTree = ({ createdDate }: Param, isManual = false) =>
  useApi<ProJobCategoriesForSignup>(
    {
      params: { createdDate },
      url: 'pro-job-categories-for-signup/tree',
    },
    isManual ? { manual: true } : {}
  );

export default useGetProJobCategoriesTree;
